import ReactDOM from 'react-dom/client'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import App from './App.tsx'
import { appInsights } from './services/appInsights'

// Create emotion cache
const cache = createCache({
  key: 'css',
  prepend: true,
})

// Initialize App Insights (no config file needed - backend provides connection string)
appInsights.initialize();

// Render app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <CacheProvider value={cache}>
    <App />
  </CacheProvider>,
);
